(() => {
  'use strict';
  const dialog=document.getElementById('detail-dialog');
  if(!dialog)return;
  const art=dialog.querySelector('[data-sample-art]'),close=dialog.querySelector('[data-sample-close]'),create=dialog.querySelector('[data-sample-create]');
  const heading=dialog.querySelector('#sample-preview-title'),defaultHeading=heading?.textContent;
  let opener=null,action=null,previousOverflow='',restoreFocus=true;
  function dismiss(restore=true){restoreFocus=restore;if(dialog.open)dialog.close();}
  dialog.addEventListener('close',()=>{art.querySelectorAll('video').forEach(video=>video.pause());document.body.style.overflow=previousOverflow;if(restoreFocus&&opener?.isConnected)opener.focus({preventScroll:true});});
  close.addEventListener('click',()=>dismiss());
  dialog.addEventListener('cancel',event=>{event.preventDefault();dismiss();});
  dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dismiss();});
  create.addEventListener('click',()=>{const next=action;dismiss(false);next?.();});
  window.KeepsakeSamplePreview={close:dismiss,open(item,trigger,onCreate){
    if(!item)return;
    opener=trigger;action=onCreate;restoreFocus=true;
    art.querySelectorAll('video').forEach(video=>video.pause());
    if(heading)heading.textContent=item.name||defaultHeading;
    if(window.CanvasArtwork?.preview)art.innerHTML=window.CanvasArtwork.preview(item);else{const image=document.createElement('img');image.src=item.image;image.alt=item.alt||item.name;image.className='sample-original-image';art.replaceChildren(image);}
    art.querySelector('[role="img"]')?.setAttribute('aria-label',item.alt||item.name||defaultHeading);
    art.dataset.sampleId=item.id;
    const numberFigure=dialog.querySelector('[data-source-number-detail]');
    const numberImage=numberFigure?.querySelector('img');
    const numberSource=numberImage?.getAttribute('data-numbered-'+item.id);
    if(numberFigure){
      numberFigure.hidden=!numberSource;
      if(numberSource)numberImage.src=numberSource;
      else numberImage?.removeAttribute('src');
    }
    if(!dialog.open){previousOverflow=document.body.style.overflow;dialog.showModal();document.body.style.overflow='hidden';}
    art.querySelectorAll('video').forEach(video=>{
      const surface=video.closest('.sample-motion-surface');
      const showPoster=()=>surface?.classList.remove('is-playing');
      const fail=()=>{showPoster();video.pause();video.remove();};
      video.muted=true;
      video.playsInline=true;
      video.addEventListener('playing',()=>surface?.classList.add('is-playing'));
      video.addEventListener('pause',showPoster);
      video.addEventListener('waiting',showPoster);
      video.addEventListener('error',fail,{once:true});
      video.querySelectorAll('source').forEach(source=>source.addEventListener('error',fail,{once:true}));
      video.play()?.catch(showPoster);
    });
    close.focus({preventScroll:true});
  }};
})();
